<template>
  <div>
    <div class="form-forgot-password">
      <div class="container-fluid">
        <div style="display:flex;justify-content:center;align-items:center;">
          <div :class="forConasi ? 'forgot-page-conasi' : 'forgot-page'">
            <div class="panel panel-default">
              <div class="text-center">
                <div class="panel-body">
                  <div class="title">
                    {{ $t("forgotPassword.passwordRetrieval") }}
                  </div>
                  <form class="form" ref="form">
                    <fieldset>
                      <div class="form-group">
                        <div class="input-group">
                          <div class="input-icon">
                            <span class="input-group-addon"
                              ><i class="far fa-envelope"></i
                            ></span>
                          </div>
                          <div class="input-email">
                            <input
                              id="emailInput"
                              :placeholder="$t('forgotPassword.enterEmail')"
                              class="form-control"
                              type="email"
                              required=""
                              v-model="email"
                              @keyup.enter="onForgotPassword($event)"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="button-submit"
                        @click="onForgotPassword($event)"
                      >
                        <span />
                        <input
                          :value="$t('forgotPassword.send')"
                          type="submit"
                        />
                        <span />
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import functionUtils from "Utils/functionUtils";
import LoginFromType from "Enum/loginFromType.js";
// import ToastType from 'enum/toastType.js';
import stringUtils from "Utils/stringUtils";
import { FOR_CONASI_TARGET } from 'Utils/constants'

export default {
  data: () => ({
    email: null,
    isLoading: false,
    forConasi: FOR_CONASI_TARGET
  }),
  methods: {
    ...mapActions(["ON_SHOW_TOAST", "SEND_EMAIL_FORGOT_PASSWORD"]),

    requiredValue(value) {
      if (!functionUtils.isNull(value) && value.length !== 0) {
        return true;
      }
      return this.$t("common.requiredFields");
    },
    validEmail(email) {
      if (!email) {
        return false;
      }
      const re = /^([\w\d._\-#])+@([\w\d._\-#]+[.][\w\d._\-#]+)+$/;
      return re.test(String(email).toLowerCase());
    },
    // Validate
    validate() {
      if (this.validEmail(this.email)) {
        let filter = {
          email: this.email,
          fromDomainType: LoginFromType.CUSTOMER,
          domainWithBasePath: stringUtils.DOMAIN_BASE_PATH,
        };
        this.isLoading = true;
        this.SEND_EMAIL_FORGOT_PASSWORD(filter)
          .then(
            function() {
              this.isLoading = false;
              this.$toast.clear();
              this.$toast.success(
                this.$t("forgotPassword.pleaseCheckEmailToChangePassword"), {
                  position: "bottom-left",
                  timeout: 1500,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  draggable: true,
                  draggablePercent: 0.6,
                  showCloseButtonOnHover: false,
                  hideProgressBar: false,
                  closeButton: "button",
                  icon: true,
                  rtl: false,
                }
              );
              this.email = null;
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
              this.$toast.clear();
              this.$toast.error(this.$t(functionUtils.errorResponse(error.response)), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false,
              });
            }.bind(this)
          );
      }
    },
    onForgotPassword: function(event) {
      event.preventDefault();
      this.validate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.forgot-page-conasi {
  width: 33vw;
  height: auto;
  .container {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
  }
  .panel-body {
    background-color: #f7fafc;
    box-shadow: 0 0px 17px 0 rgba(0, 0, 0, 0.1);
    padding: 0 38px 83px 38px;
    border-radius: 5px;;
    .title {
      font-size: 18px;
      font-weight: 600;
      color: $primary;
      text-align: center;
      padding: 16px 0 74px 0;
    }
    .form-group {
      background-color: #fff;
      margin-bottom: 35px;
      .input-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        ::-webkit-input-placeholder,
        :-ms-input-placeholder,
        ::placeholder {
          font-size: 15px;
          color: $primary;
        }
        .input-icon {
          width: 57px;
          svg {
            font-size: 22px;
            color: $primary;
          }
        }
        .input-email {
          width: calc(100% - 57px);
          input {
            height: 50px;
            border: none;
            color: $primary;
            &:focus {
              box-shadow: none;
            }
          }
        }
      }
    }
    .button-submit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $primary;
      color: #fff;
      border: $primary;
      margin-top: 20px;
      border-radius: 5px;
      cursor: pointer;
      padding: 0px 17px;
      &:hover {
        background-color: #a5563e;
      }
      &:active {
        box-shadow: 0 0 0 0.2rem rgba(227, 137, 137, 0.5);
      }
      input {
        border: none;
        background: transparent;
        color: #fff;
        padding: 13px 0;
        &:focus {
          outline: none;
        }
      }
    }
  }
}
.forgot-page {
  min-width: 300px;
  height: auto;
  .container {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
  }
  .panel-body {
    padding: 0 38px 83px 38px;
    .title {
      font-size: 20px;
      font-weight: 600;
      color: $btn-background;
      text-align: center;
      padding: 2em 0;
    }
    .form-group {
      background-color: #fff;
      .input-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 0px 5px 0 rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        ::-webkit-input-placeholder,
        :-ms-input-placeholder,
        ::placeholder {
          font-size: 15px;
          color: lightgray;
        }
        .input-icon {
          width: 48px;
          svg {
            font-size: 22px;
            color: $btn-background;
          }
        }
        .input-email {
          width: calc(100% - 48px);
          input {
            height: 48px;
            border: none;
            color: $text-input-form;
            &:focus {
              box-shadow: none;
            }
          }
        }
      }
    }
    .button-submit {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $btn-background;
      color: #fff;
      border: $primary;
      margin-top: 20px;
      border-radius: 5px;
      cursor: pointer;
      padding: 0px 17px;
      &:hover {
        background-color: #a5563e;
      }
      &:active {
        box-shadow: 0 0 0 0.2rem rgba(227, 137, 137, 0.5);
      }
      input {
        border: none;
        background: transparent;
        color: #fff;
        padding: 13px 0;
        &:focus {
          outline: none;
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .forgot-page-conasi {
    width: 70vw;
  }
}

@media only screen and (max-width: 769px) {
  .forgot-page-conasi {
    width: 80vw;
  }
}
</style>
